import { React } from 'react';
import { takeLatest, put, call, select } from 'redux-saga/effects';

import { toast } from 'react-toastify';
import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import {
  ADD_ACTIVITY,
  ADD_NEW_GROUP,
  COTUTORS_LIST_GET,
  COURSE_CANCEL,
  COURSE_CREATE,
  COURSE_SAVING,
  COURSE_UPDATE,
  EDIT_GROUP,
  GROUP_DELETE,
  GROUP_IMPORT_TEMPLATE_GET,
  GROUP_LIST_GET,
  GROUP_USERS_GET,
  QUIZ_CREATE,
  QUIZ_DELETE,
  QUIZ_DETAILS_GET,
  QUIZ_UPDATE,
  SESSION_CREATE,
  SESSION_UPDATE,
  SURVEY_LIST_GET,
  TAG_LIST_GET,
  TEMP_QUIZ_SAVE,
  TUTORS_LIST_GET,
  UPDATE_ACTIVITY,
  USER_LIST_GET,
} from '../actions/tutors';
import tutors from '../../api/tutors';
import { ToastError } from '../../../ui/components/Toast';
import routes from '../../../routes';
import { STATS_GROUP_LIST_GET } from '../actions/statistics';
import { errorHandling } from '../../../utils/errors';

function* tutorsListGet({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      tutors.tutorsListGet,
      id
    );
    yield put({ type: TUTORS_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > tutorsListGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* tutorsListGetWatch() {
  yield takeLatest(TUTORS_LIST_GET._REQUEST, tutorsListGet);
}

function* cotutorsListGet({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      tutors.cotutorsListGet,
      id
    );
    yield put({ type: COTUTORS_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > cotutorsListGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* cotutorsListGetWatch() {
  yield takeLatest(COTUTORS_LIST_GET._REQUEST, cotutorsListGet);
}

function* tagListGet({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      tutors.tagListGet,
      filters
    );
    yield put({ type: TAG_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > tagListGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* tagListGetWatch() {
  yield takeLatest(TAG_LIST_GET._REQUEST, tagListGet);
}

function* surveyListGet({ id, typology }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      tutors.surveyListGet,
      id,
      typology
    );
    yield put({ type: SURVEY_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > surveyListGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* surveyListGetWatch() {
  yield takeLatest(SURVEY_LIST_GET._REQUEST, surveyListGet);
}

function* userListGet({ payload }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      tutors.userListGet,
      payload
    );
    yield put({ type: USER_LIST_GET._SUCCESS, response, pager, payload });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > userListGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* userListGetWatch() {
  yield takeLatest(USER_LIST_GET._REQUEST, userListGet);
}

function* quizCreate({ body, secId, actId, field, value }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      tutors.quizCreate,
      body
    );
    yield put({ type: QUIZ_CREATE._SUCCESS, response });
    yield put({
      type: UPDATE_ACTIVITY,
      secId,
      actId,
      field,
      value: { ...value, id: response?.id },
    });
    yield put({
      type: TEMP_QUIZ_SAVE,
      id: response.id,
      quizDetails: value,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > quizCreate', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* quizCreateWatch() {
  yield takeLatest(QUIZ_CREATE._REQUEST, quizCreate);
}

function* quizUpdate({ quizId, body, secId, actId, field, value }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      tutors.quizUpdate,
      quizId,
      body
    );
    yield put({ type: QUIZ_UPDATE._SUCCESS, response });
    yield put({
      type: UPDATE_ACTIVITY,
      secId,
      actId,
      field,
      value: { ...value, id: quizId },
    });
    yield put({
      type: TEMP_QUIZ_SAVE,
      id: quizId,
      quizDetails: value,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > quizUpdate', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* quizUpdateWatch() {
  yield takeLatest(QUIZ_UPDATE._REQUEST, quizUpdate);
}

function* quizDetailsGet({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      tutors.quizDetailsGet,
      id
    );
    yield put({ type: QUIZ_DETAILS_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > quizDetailsGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* quizDetailsGetWatch() {
  yield takeLatest(QUIZ_DETAILS_GET._REQUEST, quizDetailsGet);
}

function* groupListGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(tutors.groupListGet);
    yield put({ type: GROUP_LIST_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > groupListGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* groupListGetWatch() {
  yield takeLatest(GROUP_LIST_GET._REQUEST, groupListGet);
}

function* newGroupAdd({ group }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      tutors.newGroupAdd,
      group
    );
    yield put({ type: ADD_NEW_GROUP._SUCCESS, response });
    yield put({ type: GROUP_LIST_GET._REQUEST });
    yield put({ type: STATS_GROUP_LIST_GET._REQUEST });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > newGroupAdd', err);
    toast.error(
      <ToastError title="Creazione gruppo fallita" body={err?.data?.message} />
    );
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* newGroupAddWatch() {
  yield takeLatest(ADD_NEW_GROUP._REQUEST, newGroupAdd);
}

function* groupEdit({ id, payload, filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      tutors.groupEdit,
      id,
      payload
    );
    yield put({ type: EDIT_GROUP._SUCCESS, response });
    yield put({ type: GROUP_LIST_GET._REQUEST });
    yield put({ type: STATS_GROUP_LIST_GET._REQUEST });
    yield put({ type: GROUP_USERS_GET._REQUEST, id });
    yield put({ type: USER_LIST_GET._REQUEST, payload: filters });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > groupEdit', err);
    if (err.code === 403) {
      const msg = err?.data?.message?.includes('PPG/GURA005')
        ? 'Non è possibile rimuovere tutti i tutor'
        : '"Non sei autorizzato a modificare il gruppo"';
      toast.error(<ToastError title="Attenzione!" body={msg} />);
    }
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* groupEditWatch() {
  yield takeLatest(EDIT_GROUP._REQUEST, groupEdit);
}

function* getGroupUsers({ id, filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      tutors.userListGet,
      {
        ...filters,
        group_ids: id,
      }
    );
    yield put({ type: GROUP_USERS_GET._SUCCESS, response, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > getGroupUsers', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* getGroupUsersWatch() {
  yield takeLatest(GROUP_USERS_GET._REQUEST, getGroupUsers);
}

function* groupImportTemplateGet({ templateType }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      tutors.groupImportTemplateGet,
      templateType
    );
    yield put({ type: GROUP_IMPORT_TEMPLATE_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > groupImportTemplateGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* groupImportTemplateGetWatch() {
  yield takeLatest(GROUP_IMPORT_TEMPLATE_GET._REQUEST, groupImportTemplateGet);
}

function* courseCreate({ payload }) {
  try {
    yield put({ type: LOADER_OPEN });
    yield put({ type: COURSE_SAVING, saving: true });
    const { data: { data: response } = {} } = yield call(
      tutors.courseCreate,
      payload
    );
    yield put({ type: COURSE_CREATE._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > courseCreate', err);
    yield put({ type: COURSE_CREATE._ERROR });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* courseCreateWatch() {
  yield takeLatest(COURSE_CREATE._REQUEST, courseCreate);
}

function* courseUpdate({ id, payload }) {
  try {
    yield put({ type: LOADER_OPEN });
    yield put({ type: COURSE_SAVING, saving: true });
    const { data: { data: response } = {} } = yield call(
      tutors.courseUpdate,
      id,
      payload
    );
    yield put({ type: COURSE_UPDATE._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > courseUpdate', err);
    yield put({ type: COURSE_UPDATE._ERROR });
    yield put({ type: COURSE_SAVING, saving: false });
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* courseUpdateWatch() {
  yield takeLatest(COURSE_UPDATE._REQUEST, courseUpdate);
}

function* courseCancel({ navigate }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { isTutor, isSupervisor } = yield select((state) => state.user);
    const { tempQuiz: { data: newQuiz } = {}, newGroupIds = [] } = yield select(
      (state) => state.tutors
    );
    const newQuizIds = Object.keys(newQuiz || {});
    if (newQuizIds?.length > 0) {
      yield put({ type: QUIZ_DELETE._REQUEST, ids: newQuizIds });
    }
    if (newGroupIds?.length > 0 && isTutor && !isSupervisor) {
      yield put({ type: GROUP_DELETE._REQUEST, ids: newGroupIds });
    }
    yield put({ type: COURSE_CANCEL._SUCCESS });
    if (typeof navigate === 'function') navigate(routes.home.path);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > courseCancel', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* courseCancelWatch() {
  yield takeLatest(COURSE_CANCEL._REQUEST, courseCancel);
}

function* quizDelete({ ids }) {
  try {
    yield put({ type: LOADER_OPEN });
    for (const id of ids) {
      yield call(tutors.quizDelete, id);
    }
    yield put({ type: QUIZ_DELETE._SUCCESS });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > quizDelete', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* quizDeleteWatch() {
  yield takeLatest(QUIZ_DELETE._REQUEST, quizDelete);
}

function* groupDelete({ ids, callback }) {
  try {
    yield put({ type: LOADER_OPEN });
    for (const id of ids) {
      yield call(tutors.groupDelete, id);
    }
    yield put({ type: GROUP_DELETE._SUCCESS });
    if (typeof callback === 'function') yield callback();
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > groupDelete', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* groupDeleteWatch() {
  yield takeLatest(GROUP_DELETE._REQUEST, groupDelete);
}

function* sessionCreate({ body, secId, activityType, field, isCopy }) {
  try {
    yield put({ type: ADD_ACTIVITY, secId, activityType });
    const { actCount: actId } = yield select(
      (state) => state.tutors.activities
    );
    yield put({
      type: UPDATE_ACTIVITY,
      secId,
      actId,
      field,
      value: body,
      isCopy,
    });
    yield put({ type: SESSION_CREATE._SUCCESS });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > sessionCreate', err);
  }
}

function* sessionCreateWatch() {
  yield takeLatest(SESSION_CREATE._REQUEST, sessionCreate);
}

function* sessionUpdate({ body, secId, actId, field, sessionId }) {
  try {
    yield put({
      type: UPDATE_ACTIVITY,
      secId,
      actId,
      field,
      value: { ...body, id: sessionId },
    });
    yield put({ type: SESSION_UPDATE._SUCCESS });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > tutors > sessionUpdate', err);
  }
}

function* sessionUpdateWatch() {
  yield takeLatest(SESSION_UPDATE._REQUEST, sessionUpdate);
}

export default [
  tutorsListGetWatch(),
  cotutorsListGetWatch(),
  tagListGetWatch(),
  surveyListGetWatch(),
  quizCreateWatch(),
  quizUpdateWatch(),
  quizDetailsGetWatch(),
  userListGetWatch(),
  groupListGetWatch(),
  newGroupAddWatch(),
  groupEditWatch(),
  courseCreateWatch(),
  courseUpdateWatch(),
  courseCancelWatch(),
  quizDeleteWatch(),
  groupDeleteWatch(),
  sessionCreateWatch(),
  sessionUpdateWatch(),
  getGroupUsersWatch(),
  groupImportTemplateGetWatch(),
];
